import { styled } from "@mui/material";

export const ModuleTitleContainer = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.primary.contrastText,
}));
